import { Component, ViewChild, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment-rejected-modal',
    templateUrl: './payment-rejected-modal.component.html',
    styleUrls: ['./payment-rejected-modal.component.scss']
})
export class PaymentRejectedModalComponent
{
    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    public onCloseClick(): void
    {
        this.modal.close('closed by click');
    }

    public open(closeable = true): void
    {
        this.modal.open(closeable);
    }
}
